export const PATIENT_APP_EVENT_NAME = 'patient';
export const ADMIN_APP_EVENT_NAME = 'admin';
export const LEGACY_ADMIN_APP_EVENT_NAME = 'legacy-admin';
export const LEGACY_PATIENT_APP_EVENT_NAME = 'legacy-patient';
export const isAppEventInstance = (object, appName) => {
    return 'type' in object && object.type === appName;
};
export const isEventInstance = (object, eventName) => {
    return 'eventName' in object && object.eventName === eventName;
};
export class AppEvent {
    name;
    data;
    constructor(name, data) {
        this.name = name;
        this.data = data;
    }
}
export class AdminAppEvent extends AppEvent {
    constructor(data) {
        super(ADMIN_APP_EVENT_NAME, data);
    }
    static isInstanceOf = (object) => {
        return isAppEventInstance(object, ADMIN_APP_EVENT_NAME);
    };
}
export class LegacyAdminAppEvent extends AppEvent {
    constructor(data) {
        super(LEGACY_ADMIN_APP_EVENT_NAME, data);
    }
    static isInstanceOf = (object) => {
        return isAppEventInstance(object, LEGACY_ADMIN_APP_EVENT_NAME);
    };
}
export class PatientAppEvent extends AppEvent {
    constructor(data) {
        super(PATIENT_APP_EVENT_NAME, data);
    }
    static isInstanceOf = (object) => {
        return isAppEventInstance(object, PATIENT_APP_EVENT_NAME);
    };
}
export class LegacyPatientAppEvent extends AppEvent {
    constructor(data) {
        super(LEGACY_PATIENT_APP_EVENT_NAME, data);
    }
    static isInstanceOf = (object) => {
        return isAppEventInstance(object, LEGACY_PATIENT_APP_EVENT_NAME);
    };
}
